module.exports = __webpack_public_path__ + "static/img/ability_en.6e7fda4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/ability_en.jpg
// module id = k1eF
// module chunks = 3